import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("{{! @glint-nocheck: not typesafe yet }}\n<li aria-label={{t \"drafts.components.post-list.card.aria.draft_post\"}} class=\"cPL--card qa--post_card\" tabindex=\"0\">\n  <div class=\"cPL--cardHeader\">\n    <div class=\"cPL--cardHeader__section\">\n      <div aria-label={{t \"shared_phrases.social_profile\"}} class=\"cPL--cardHeader__profile\" role=\"group\" tabindex=\"0\">\n        <Shared::ProfileAvatar\n          @showDetails={{true}}\n          @showOutline={{true}}\n          @showPlatform={{true}}\n          @socialProfile={{@post.socialProfile}}\n          aria-label={{@post.socialProfile.profileType}}\n          class=\"cPL--cardHeader__user\"\n          tabindex=\"0\"\n        />\n      </div>\n    </div>\n    <div class=\"cPL--cardHeader__section\">\n      <p\n        aria-label={{t \"drafts.components.post-list.card.label.selected_time\"}}\n        class=\"cPL--cardHeader__selectedTime qa--post_selectedTime\"\n        role=\"group\"\n        tabindex=\"0\"\n      >\n        {{#if this.publishingIcon}}\n          {{svg-jar this.publishingIcon class=\"o--icon--sm u--m__r__xs qa--post_postTypeIcon\"}}\n        {{/if}}\n        <span>\n          {{t \"drafts.components.post-list.card.label.selected_time\"}}\n        </span>\n        <span tabindex=\"0\">\n          {{this.selectedTime}}\n        </span>\n      </p>\n      <div class=\"cPL--cardHeader__actionBtn\" tabindex=\"-1\">\n        <Shared::Ui::Button\n          @additional=\"circle\"\n          @onClick={{action this.onClickEditButton}}\n          @variant=\"outline\"\n          aria-label={{t \"drafts.components.post-list.card.aria.edit_post\"}}\n          class=\"qa--post_editBtn\"\n          type=\"button\"\n        >\n          {{svg-jar \"edit\" class=\"o--icon o--icon-lg\"}}\n        </Shared::Ui::Button>\n      </div>\n    </div>\n  </div>\n  <div class=\"cPL--cardBody\">\n    {{#unless @post.isText}}\n      {{! Media }}\n      <div class=\"cPL--cardBody__media {{if this.hasTallImage 'cPL--cardBody__media--tall'}}\">\n        <LinkTo\n          @loadingClass=\"\"\n          @model={{@post.id}}\n          @query={{this.editRouteParams}}\n          @route={{@editRoute}}\n          aria-label={{this.captionLabel}}\n          role=\"link\"\n          tabindex=\"0\"\n        >\n          <figure class=\"o--mediaContainer\">\n            {{#if this.mediaIcon}}\n              <span class=\"o--media__label--type\">\n                {{svg-jar this.mediaIcon class=\"o--icon--md o--icon--white\"}}\n              </span>\n            {{/if}}\n            <img\n              alt={{@post.caption}}\n              class=\"o--media\"\n              data-test-image\n              onerror={{this.onImageError}}\n              src={{@post.calendarOrProcessingUrl}}\n            />\n            <b class=\"o--mediaOverlay\"></b>\n          </figure>\n        </LinkTo>\n      </div>\n    {{/unless}}\n    <div class=\"cPL--cardBody__detailWrapper\">\n\n      {{! Post Details: Required Fields }}\n      <Schedule::PostList::PostDetails @captionLabel={{this.captionLabel}} @post={{@post}} />\n\n      {{! Post Details: Optional Fields }}\n      {{#if this.showAddedOptions}}\n        <div\n          aria-label={{t \"drafts.components.post-list.card.label.added_options\"}}\n          class=\"cPL--cardBody__detail\"\n          role=\"group\"\n          tabindex=\"0\"\n        >\n          <h5 class=\"cPL--cardBody__title qa--post_addedOptions_title\">\n            {{t \"drafts.components.post-list.card.label.added_options\"}}\n          </h5>\n          <ul class=\"cPL--cardBody__optionList qa--post_addedOptions_list\">\n            {{#if this.addedOptions.length}}\n              {{#each this.addedOptions as |option|}}\n                <li class={{concat-classes \"cPL--cardBody__option\" (if option.class option.class)}}>\n                  {{svg-jar option.icon class=\"o--icon o--icon--sm\"}}\n                  <span tabindex=\"0\">\n                    {{option.label}}\n                  </span>\n                </li>\n              {{/each}}\n            {{else}}\n              -{{! Empty indicator }}\n            {{/if}}\n          </ul>\n        </div>\n      {{/if}}\n    </div>\n  </div>\n</li>", {"contents":"{{! @glint-nocheck: not typesafe yet }}\n<li aria-label={{t \"drafts.components.post-list.card.aria.draft_post\"}} class=\"cPL--card qa--post_card\" tabindex=\"0\">\n  <div class=\"cPL--cardHeader\">\n    <div class=\"cPL--cardHeader__section\">\n      <div aria-label={{t \"shared_phrases.social_profile\"}} class=\"cPL--cardHeader__profile\" role=\"group\" tabindex=\"0\">\n        <Shared::ProfileAvatar\n          @showDetails={{true}}\n          @showOutline={{true}}\n          @showPlatform={{true}}\n          @socialProfile={{@post.socialProfile}}\n          aria-label={{@post.socialProfile.profileType}}\n          class=\"cPL--cardHeader__user\"\n          tabindex=\"0\"\n        />\n      </div>\n    </div>\n    <div class=\"cPL--cardHeader__section\">\n      <p\n        aria-label={{t \"drafts.components.post-list.card.label.selected_time\"}}\n        class=\"cPL--cardHeader__selectedTime qa--post_selectedTime\"\n        role=\"group\"\n        tabindex=\"0\"\n      >\n        {{#if this.publishingIcon}}\n          {{svg-jar this.publishingIcon class=\"o--icon--sm u--m__r__xs qa--post_postTypeIcon\"}}\n        {{/if}}\n        <span>\n          {{t \"drafts.components.post-list.card.label.selected_time\"}}\n        </span>\n        <span tabindex=\"0\">\n          {{this.selectedTime}}\n        </span>\n      </p>\n      <div class=\"cPL--cardHeader__actionBtn\" tabindex=\"-1\">\n        <Shared::Ui::Button\n          @additional=\"circle\"\n          @onClick={{action this.onClickEditButton}}\n          @variant=\"outline\"\n          aria-label={{t \"drafts.components.post-list.card.aria.edit_post\"}}\n          class=\"qa--post_editBtn\"\n          type=\"button\"\n        >\n          {{svg-jar \"edit\" class=\"o--icon o--icon-lg\"}}\n        </Shared::Ui::Button>\n      </div>\n    </div>\n  </div>\n  <div class=\"cPL--cardBody\">\n    {{#unless @post.isText}}\n      {{! Media }}\n      <div class=\"cPL--cardBody__media {{if this.hasTallImage 'cPL--cardBody__media--tall'}}\">\n        <LinkTo\n          @loadingClass=\"\"\n          @model={{@post.id}}\n          @query={{this.editRouteParams}}\n          @route={{@editRoute}}\n          aria-label={{this.captionLabel}}\n          role=\"link\"\n          tabindex=\"0\"\n        >\n          <figure class=\"o--mediaContainer\">\n            {{#if this.mediaIcon}}\n              <span class=\"o--media__label--type\">\n                {{svg-jar this.mediaIcon class=\"o--icon--md o--icon--white\"}}\n              </span>\n            {{/if}}\n            <img\n              alt={{@post.caption}}\n              class=\"o--media\"\n              data-test-image\n              onerror={{this.onImageError}}\n              src={{@post.calendarOrProcessingUrl}}\n            />\n            <b class=\"o--mediaOverlay\"></b>\n          </figure>\n        </LinkTo>\n      </div>\n    {{/unless}}\n    <div class=\"cPL--cardBody__detailWrapper\">\n\n      {{! Post Details: Required Fields }}\n      <Schedule::PostList::PostDetails @captionLabel={{this.captionLabel}} @post={{@post}} />\n\n      {{! Post Details: Optional Fields }}\n      {{#if this.showAddedOptions}}\n        <div\n          aria-label={{t \"drafts.components.post-list.card.label.added_options\"}}\n          class=\"cPL--cardBody__detail\"\n          role=\"group\"\n          tabindex=\"0\"\n        >\n          <h5 class=\"cPL--cardBody__title qa--post_addedOptions_title\">\n            {{t \"drafts.components.post-list.card.label.added_options\"}}\n          </h5>\n          <ul class=\"cPL--cardBody__optionList qa--post_addedOptions_list\">\n            {{#if this.addedOptions.length}}\n              {{#each this.addedOptions as |option|}}\n                <li class={{concat-classes \"cPL--cardBody__option\" (if option.class option.class)}}>\n                  {{svg-jar option.icon class=\"o--icon o--icon--sm\"}}\n                  <span tabindex=\"0\">\n                    {{option.label}}\n                  </span>\n                </li>\n              {{/each}}\n            {{else}}\n              -{{! Empty indicator }}\n            {{/if}}\n          </ul>\n        </div>\n      {{/if}}\n    </div>\n  </div>\n</li>","moduleName":"later/components/schedule/post-list/card.hbs","parseOptions":{"srcName":"later/components/schedule/post-list/card.hbs"}});
import { assert } from '@ember/debug';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import moment from 'moment';

import type RouterService from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';
import type GramModel from 'later/models/gram';
import type PostMediaItemModel from 'later/models/post-media-item';
import type ErrorsService from 'later/services/errors';
import type { Transition } from 'shared/types';

interface PostOption {
  icon: string;
  label: string;
  class?: string;
}

interface PostListCardComponentArgs {
  post: GramModel;
  editRoute: string;
}

export default class PostListCardComponent extends Component<PostListCardComponentArgs> {
  @service declare errors: ErrorsService;
  @service declare intl: IntlService;
  @service declare router: RouterService;

  constructor(owner: unknown, args: PostListCardComponentArgs) {
    super(owner, args);
    assert('`post` is required', typeof args.post === 'object');
    assert('`editRoute` is required', typeof args.editRoute === 'string');
  }

  get isDescription(): boolean {
    return this.args.post.isPinterest || this.args.post.isYoutube;
  }

  get captionLabel(): string {
    return this.isDescription ? this.intl.t('post.caption.description_title') : this.intl.t('post.caption.title');
  }

  get selectedTime(): string {
    const { scheduledTime } = this.args.post;
    if (!scheduledTime) {
      throw new Error("Unable to use gram's `scheduledTime` to display `selectedTime`");
    }

    return moment.unix(scheduledTime).format('MMM Do YYYY - h:mm A');
  }

  get mediaIcon(): string {
    const { isTiktok, isReel, isCarouselPost, isVideo } = this.args.post;
    if (isTiktok) {
      return 'lib-tiktok';
    } else if (isReel) {
      return 'ig-reels';
    } else if (isCarouselPost) {
      return 'gallery';
    } else if (isVideo) {
      return 'video';
    }
    return '';
  }

  get publishingIcon(): 'instant' | 'notification' {
    if (this.args.post.isNotificationPost) {
      return 'notification';
    }

    return 'instant';
  }

  get postMediaItemsWithProductTags(): PostMediaItemModel[] {
    return this.args.post.postMediaItems.filter((postMediaItem) => Boolean(postMediaItem.productTags?.length));
  }

  get hasClickTracking(): boolean {
    return Boolean(this.args.post.clickTracking);
  }

  get hasLocation(): boolean {
    return Boolean(this.args.post.locationId);
  }

  get hasFirstComment(): boolean {
    return Boolean(this.args.post.isFirstCommentActive);
  }

  get hasLinkinBio(): boolean {
    return Boolean(this.args.post.linkinbioPost?.get('id'));
  }

  get hasPinterestLinkUrl(): boolean {
    return Boolean(this.args.post.isPinterest && this.args.post.linkUrl);
  }

  get hasTaggedUsers(): boolean {
    return Boolean(this.args.post.taggedUsers?.length > 0);
  }

  get hasTaggedProducts(): boolean {
    return Boolean(this.postMediaItemsWithProductTags?.length > 0);
  }

  get hasTallImage(): boolean {
    return Boolean(this.args.post.isTiktok || this.args.post.isReel || this.args.post.isYoutube);
  }

  get hasKeywordTags(): boolean {
    return Boolean(this.args.post.keywordTags?.length);
  }

  get hasVideoCategory(): boolean {
    return Boolean(this.args.post.category);
  }

  get hasNotifySubscribersOn(): boolean {
    return this.args.post.notifySubscribers;
  }

  get showAddedOptions(): boolean {
    const { isFacebook, isLinkedin } = this.args.post;
    if (isFacebook || isLinkedin) {
      return false;
    }

    return true;
  }

  get addedOptions(): PostOption[] {
    const options: PostOption[] = [];

    if (this.hasFirstComment) {
      options.push({
        icon: 'first-comment',
        label: this.intl.t('post.body.first_comment'),
        class: 'qa--post_addedOptions_option_firstComment'
      });
    }
    if (this.hasLinkinBio) {
      options.push({
        icon: 'linkin-bio',
        label: this.intl.t('shared_words.linkinbio'),
        class: 'qa--post_addedOptions_option_linkinBio'
      });
    }
    if (this.hasPinterestLinkUrl) {
      options.push({
        icon: 'link',
        label: this.intl.t('post.body.website'),
        class: 'qa--post_addedOptions_option_website'
      });
    }
    if (this.hasLocation) {
      options.push({
        icon: 'location',
        label: this.intl.t('post.body.location'),
        class: 'qa--post_addedOptions_option_location'
      });
    }
    if (this.hasTaggedUsers) {
      options.push({
        icon: 'tag-user',
        label: this.intl.t('shared_phrases.tag_users'),
        class: 'qa--post_addedOptions_option_tagUser'
      });
    }
    if (this.hasTaggedProducts) {
      options.push({
        icon: 'tag-product',
        label: this.intl.t('shared_phrases.tag_products'),
        class: 'qa--post_addedOptions_option_tagProduct'
      });
    }
    if (this.hasClickTracking) {
      options.push({
        icon: 'link',
        label: this.intl.t('post.body.click_tracking'),
        class: 'qa--post_addedOptions_option_clickTracking'
      });
    }
    if (this.hasKeywordTags) {
      options.push({
        icon: 'label',
        label: this.intl.t('post.youtube.tags.label'),
        class: 'qa--post_addedOptions_option_keywordTags'
      });
    }
    if (this.hasVideoCategory) {
      options.push({
        icon: 'category',
        label: this.intl.t('post.youtube.category.label'),
        class: 'qa--post_addedOptions_option_videoCategory'
      });
    }
    if (this.hasNotifySubscribersOn) {
      options.push({
        icon: 'notify',
        label: this.intl.t('post.notify_subscribers.label'),
        class: 'qa--post_addedOptions_option_notifySubscribers'
      });
    }

    return options;
  }

  get editRouteParams(): object {
    return {
      draft: true,
      backTo: 'cluster.schedule.drafts'
    };
  }

  @action
  onClickEditButton(): void {
    const { editRouteParams: queryParams } = this;
    this.router.transitionTo(this.args.editRoute, this.args.post.id, { queryParams }) as Transition;
  }

  @action
  onImageError(error: Error): void {
    this.errors.log(error);
  }
}
